module.exports = __webpack_public_path__ + "27e8bff24d1a1ba3f46e64d76654b6ed.svg";